var _path, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { createSvgIconFromGenerated } from '../utils';
var SvgBlik = function SvgBlik(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 20 20",
    width: "1em",
    height: "1em",
    focusable: "false",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#blik_svg__a)",
    fillRule: "evenodd",
    d: "M4.197 0A4.211 4.211 0 0 0 0 4.2v11.6C0 18.112 1.89 20 4.197 20H15.8c2.31 0 4.2-1.889 4.2-4.2V4.2C20 1.89 18.11 0 15.8 0H4.197Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#blik_svg__b)",
    fillRule: "evenodd",
    d: "M10.313 4.531a2.344 2.344 0 1 0 4.687 0 2.344 2.344 0 0 0-4.688 0Z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M10.156 15.303a2.33 2.33 0 1 1 0-4.662 2.33 2.33 0 0 1 0 4.662Zm0-7.174c-.828 0-1.608.208-2.29.575V3.125H5.313v9.846a4.844 4.844 0 1 0 4.843-4.842Z",
    clipRule: "evenodd"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "blik_svg__a",
    x1: 10,
    x2: 10,
    y1: 20,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#595959"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "blik_svg__b",
    x1: 10.999,
    x2: 14.313,
    y1: 2.874,
    y2: 6.189,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E52E07"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E94E96"
  })))));
};
export default createSvgIconFromGenerated(SvgBlik, "Blik");